
(function() {
  var result = { translations: { "bn": { "i18n": { "duration": { "seconds": "{{ seconds }}\u09B8\u09C7\u0995", "minutes": "{{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "hours": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE", "hoursAndMinutes": "{{ hours }}\u0998\u09A8\u09CD\u099F\u09BE {{ minutes }}\u09AE\u09BF\u09A8\u09BF\u099F", "days": "{{ days }}\u09A6\u09BF\u09A8\xA0", "shortForm": { "seconds": "{{ seconds }}\u09B8\u09C7", "minutes": "{{ minutes }}\u09AE\u09BF\xA0", "hours": "{{ hours }}\u0998", "days": "{{ days }}\u09A6\u09BF\xA0", "hoursAndMinutes": "{{ hours }}\u0998 {{ minutes }}\u09AE\u09BF" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}},\u098F\u0995\u09CD\u09B8\u099F.{{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "bn": "static-7.1320"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1320",
    "ar-eg": "static-7.1320",
    "bg": "static-7.1320",
    "bn": "static-7.1320",
    "ca-es": "static-7.1320",
    "cs": "static-7.1320",
    "da": "static-7.1320",
    "de": "static-7.1320",
    "el": "static-7.1320",
    "en-gb": "static-7.1320",
    "en": "static-7.1320",
    "es-mx": "static-7.1320",
    "es": "static-7.1320",
    "et": "static-7.1320",
    "fi": "static-7.1320",
    "fr-ca": "static-7.1320",
    "fr": "static-7.1320",
    "he-il": "static-7.1320",
    "hi": "static-7.1320",
    "hr": "static-7.1320",
    "hu": "static-7.1320",
    "id": "static-7.1320",
    "it": "static-7.1320",
    "ja": "static-7.1320",
    "ko": "static-7.1320",
    "lt": "static-7.1320",
    "ms": "static-7.1320",
    "nl": "static-7.1320",
    "no": "static-7.1320",
    "pl": "static-7.1320",
    "pt-br": "static-7.1320",
    "pt-pt": "static-7.1320",
    "ro": "static-7.1320",
    "ru": "static-7.1320",
    "sk": "static-7.1320",
    "sl": "static-7.1320",
    "sv": "static-7.1320",
    "th": "static-7.1320",
    "tl": "static-7.1320",
    "tr": "static-7.1320",
    "uk": "static-7.1320",
    "vi": "static-7.1320",
    "x-pseudo": "static-7.1320",
    "zh-cn": "static-7.1320",
    "zh-hk": "static-7.1320",
    "zh-tw": "static-7.1320"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:bn', {version: 'static-7.1320'}); }
})();


